import { __read, __spreadArray } from "tslib";
import * as fillTypes from '../../constants/fillTypes';
import * as convert from '../convertColours';
export function compareColors(a, b) {
    var aHsl = convert.rgbToHsl.apply(convert, __spreadArray([], __read(a), false));
    var bHsl = convert.rgbToHsl.apply(convert, __spreadArray([], __read(b), false));
    return aHsl[0] - bHsl[0];
}
var FILLS = [fillTypes.COLOR, fillTypes.GRADIENT, fillTypes.PATTERN];
export function getColorFills(fills) {
    return fills
        .filter(function (fill) { return FILLS.indexOf(fill.content.className) !== -1; })
        .map(function (fill) {
        if (fill.content.className === fillTypes.COLOR) {
            return {
                type: 'color',
                color: fill.content.rgbaValues,
            };
        }
        if (fill.content.className === fillTypes.GRADIENT) {
            return {
                type: 'gradient',
                gradientType: fill.content.type,
                colors: getColorStops(fill.content.stops),
            };
        }
        return {
            type: 'image',
            url: fill.content.source,
        };
    });
}
export function getColorStops(colorStops) {
    return colorStops.map(function (_a) {
        var color = _a.color;
        return color.rgbaValues;
    });
}
